import { render, staticRenderFns } from "./preventBid.vue?vue&type=template&id=beaaca1e&scoped=true"
import script from "./preventBid.vue?vue&type=script&lang=js"
export * from "./preventBid.vue?vue&type=script&lang=js"
import style0 from "./preventBid.vue?vue&type=style&index=0&id=beaaca1e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beaaca1e",
  null
  
)

export default component.exports